module.exports = __webpack_public_path__ + "static/media/icon-grid.08758282.svg";